/**
 * Created by Ning Jiang on 2021-06-17.
 */

import {gsap, TimelineLite, TweenLite, Expo} from "gsap";

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";


import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {Oktoberfest} from "../Oktoberfest";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";

export class WinEffect extends PIXI.Sprite {

    public winLevel: number;

    constructor(level: number) {
        super(WinEffect.getLevelTextures(level));
        this.winLevel = level;
    }

    private static getLevelTextures(level: number): PIXI.Texture {
        switch (level) {
            case 0:
                return Oktoberfest.assetLoader.getTextures("particle_win1")[0];
            case 1:
                return Oktoberfest.assetLoader.getTextures("particle_win2")[0];
            case 2:
                return Oktoberfest.assetLoader.getTextures("particle_win3")[0];
            default:
                return Oktoberfest.assetLoader.getTextures("particle_win3")[0];
        }
    }
}

export class WinEffectView {

    private _layer: PIXI.Container;
    private _effectPool: WinEffect;

    constructor() {
        this._layer = new PIXI.Container();
        OktoberfestLayers.getLayer(Layers.WIN_PRESENTATIONS)?.addChild(this._layer);
    }

    public playAnimation(position: PIXI.Point, effectLevel: number, shouldRestrict: boolean): TimelineLite {
        const tl: TimelineLite = gsap.timeline();
        if (shouldRestrict) {
            return tl;
        }
        this._layer.position.set(position.x, position.y);
        const effect: WinEffect = this.getEffect(effectLevel);
        effect.blendMode = PIXI.BLEND_MODES.ADD;
        effect.alpha = 0;
        effect.scale.set(0);
        this._layer.addChild(effect);
        tl.add([
            new TweenLite(effect, 0.2, {alpha: 1,}),
            new TweenLite(effect.scale, 1, {x: 2, y: 2, ease: Expo.easeOut}),
            new TweenLite(effect.position, 4, {
                y: (720 * 0.5),
                ease: Expo.easeIn
            })
        ]);
        tl.add([
            new TweenLite(effect, 1.5, {alpha: 0, ease: Expo.easeOut})
        ], "-=3.5");
        tl.add([
            new TweenLite(effect.scale, 0.01, {x: 0, y: 0}),
            new TweenLite(effect.position, 0.01, {y: 1280 * 0.5})
        ]);
        tl.add(() => this.recycleEffect(effect));
        return tl;
    }

    private getEffect(effectLevel: number): WinEffect {
        if (this._effectPool) {
            return this._effectPool;
        }

        const effect = new WinEffect(effectLevel);
        effect.anchor.set(0.5);
        return effect;
    }

    private recycleEffect(effect: WinEffect): void {
        this._layer.removeChild(effect);
    }
}